const COLORS = {
  teal: "bg-[#1FBCA2] text-[#1A1D1E]",
  yellow: "bg-[#FFC837] text-[#1A1D1E]",
  coral: "bg-[#FF7B72] text-[#1A1D1E]",
  ink: "bg-[#1A1D1E] text-white",
  white: "bg-white text-[#1A1D1E]",
};

export const ChunkyButton = ({
  children,
  href = "#",
  color = "teal",
  className = "",
  testId,
}) => (
  <a
    href={href}
    data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-full border-2 border-[#1A1D1E] px-7 py-3.5 font-display text-base font-semibold shadow-[0_5px_0_0_#1A1D1E] transition-[transform,box-shadow] duration-150 hover:translate-y-[2px] hover:shadow-[0_3px_0_0_#1A1D1E] active:translate-y-[5px] active:shadow-none focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 ${COLORS[color]} ${className}`}
  >
    {children}
  </a>
);
